import { useCallback, useState } from "react";
import { isAuthenticated } from "../../auth";
import { likeProvider, unlikeProvider } from "../services/providerProductService";

// Like / Unlike a Provider from a history card. The card only changes once the server confirmed it
// (same rule as the Provider Shop's Like button); `setItems` is the history hook's updater.
export function useProviderLikeToggle(setItems) {
  const [busy, setBusy] = useState({});
  const toggle = useCallback(async (entry) => {
    const id = String(entry.providerId || entry.provider?._id);
    setBusy((b) => ({ ...b, [id]: true }));
    const token = isAuthenticated()?.token;
    const r = entry.isLikedByCurrentSeller ? await unlikeProvider(token, id) : await likeProvider(token, id);
    setBusy((b) => ({ ...b, [id]: false }));
    if (!r || r.error || r.success === false || typeof r.liked !== "boolean") return;
    setItems((items) => items.map((i) => {
      if (String(i.providerId || i.provider?._id) !== id || Boolean(i.isLikedByCurrentSeller) === r.liked) return i;
      return { ...i, isLikedByCurrentSeller: r.liked, providerLikes: Math.max(0, (i.providerLikes || 0) + (r.liked ? 1 : -1)) };
    }));
  }, [setItems]);
  return { toggle, isBusy: (entry) => Boolean(busy[String(entry.providerId || entry.provider?._id)]) };
}
